import {
  REQ_S3_URL_START,
  REQ_S3_URL_FAILED,
  S3_UPLOAD_SUCCESS,
  S3_UPLOAD_FAILED,
} from '../actions/types';

const INIT_STATE = {
  s3imgUrl: null,
  error: '',
  loading: false,
};

export default (state = INIT_STATE, action) => {
  // console.log('all auth action logger', action);
  switch (action.type) {

    case REQ_S3_URL_START:
      return {...state, ...INIT_STATE, loading: true};

    case S3_UPLOAD_SUCCESS:
      return {...state, loading: false, s3imgUrl: action.payload};

    case REQ_S3_URL_FAILED:
      return {...state, loading: false, error: action.error};
    case S3_UPLOAD_FAILED:
      return {...state, loading: false, error: action.error};

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/aws_reducer.js